import React, { useContext, useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'

// Context
import { AuthContext } from '~/hooks/auth'

// elements
import LeftSidebar from '~/elements/LeftSideBar'
import AlertRemoteUser from '~/components/AlertRemoteUser'

// functions
import { createCookie } from '~/services/functions'

// components
import LightboxAlert from '~/components/LightboxAlert'

const TemplateCourse = ({ HeaderCourse, CourseSidebar, RightSidebar, Content }) => {

  const auth = useContext(AuthContext);

  const [lightboxAlert, setLightboxAlert] = useState(auth.user.primeiro_acesso);
  const [redirectProfile, setRedirectProfile] = useState(false);

  useEffect(() => {
    setLightboxAlert(auth.user.primeiro_acesso === 1 ? true : false)
  }, [auth.user])

  const titleAlert = '<h2 class="tts-alert">Aviso</h2>';
  const msgAlert = `<p>Olá, estamos felizes com seu primeiro acesso. Aproveite para conferir se você registrou o seu nome corretamente. Após concluir o curso, o certificado será emitido para este nome e não poderá ser alterado.</p><p><strong>${auth.user.nome}</strong></p>`;

  const handdleCloseModalAlert = (pageRedirect) => {
    setLightboxAlert(false);
    auth.user.primeiro_acesso = 0;
    createCookie('@ProordemOnline:user', JSON.stringify(auth.user))

    if (pageRedirect) {
      setRedirectProfile(true)
    }
  }

  if (redirectProfile) {
    return <Redirect to='/perfil' />
  }

  return (
    <div className="full-container">
      <LeftSidebar />
      {auth.user.remoto && <AlertRemoteUser />}
      {HeaderCourse}
      {CourseSidebar}
      <div className="main-content-offset-course">
        <div className="main-content">
          {Content}
        </div>
      </div>
      {RightSidebar}
      {lightboxAlert && <LightboxAlert setLightboxAlert={handdleCloseModalAlert} title={titleAlert} msg={msgAlert} closable={false} />}
    </div>
  )
}
export default TemplateCourse